import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'

export default function Navbar(props) {
  return (
    <div>
       <nav className={`navbar navbar-expand-lg navbar-${props.mode} bg-${props.mode}`}>
  <div className="container-fluid">
    <a className="navbar-brand" href="/">{props.title}</a>
    <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
      <span className="navbar-toggler-icon"></span>
    </button>
    <div className="collapse navbar-collapse" id="navbarSupportedContent">
      <ul className="navbar-nav me-auto mb-2 mb-lg-0">
        <li className="nav-item">
          <Link className="nav-link active" to="/">Home</Link>
        </li>
        <li className="nav-item">
          <Link className="nav-link" to="/about">About</Link>
        </li>
        {/* <li className="nav-item dropdown">
          <a className="nav-link dropdown-toggle" href="/" role="button" data-bs-toggle="dropdown" aria-expanded="false">
            Dropdown
          </a>
          <ul className="dropdown-menu">
            <li><a className="dropdown-item" href="/">Action</a></li>
            <li><a className="dropdown-item" href="/">Another action</a></li>
            <li><hr className="dropdown-divider" /></li>
            <li><a className="dropdown-item" href="/">Something else here</a></li>
          </ul>
        </li> */}
        {/* <li className="nav-item">
        </li> */}
      </ul>
      {/* <form className="d-flex" role="search">
        <input className="form-control me-2" type="search" placeholder="Search" aria-label="Search" />
        <button className="btn btn-warning" type="submit">Search</button>
      </form> */}
      <strong><p className={`my-2 mx-2 text-${props.mode==='light'?'dark':'light'}`}> Pick colors for custom background</p></strong>
              <button type="button" className="btn btn-outline-primary mx-1" style={{backgroundColor:'#064306',color:'#fff'}} onClick={props.green}>Green</button>
        <button type="button" className="btn btn-outline-secondary mx-1" onClick={props.yellow} style={{backgroundColor:'rgb(127 102 1)',color:'#fff'}}>Yellow</button>
        <button type="button" className="btn btn-outline-success mx-1" onClick={props.red} style={{backgroundColor:'rgb(145 2 2)',color:'#fff'}}>Red</button>
        <button type="button" className="btn btn-outline-danger mx-1" onClick={props.black} style={{backgroundColor:'#000',color:'#fff'}}>Black</button>
      <div className={`form-check form-switch  text-${props.mode==='light'?'dark':'light'} mx-3`}>
  <input className="form-check-input" onClick={props.toggleMode} type="checkbox"  id="flexSwitchCheckDefault"/>
  <label className="form-check-label" htmlFor="flexSwitchCheckDefault">mode</label>
</div>
    </div>
  </div>
</nav>
    </div>
  )
}
Navbar.propTypes={title:PropTypes.string}